export default __webpack_public_path__ + "static/media/question_mark.03525589.svg";